<div
  class="app-download-file-from-data-container"
  [formGroup]="form"
>
  <div class="input-container">
    <div class="input-label">{{ inputLabel }}</div>
    <mat-form-field
      class="field subscripts"
      appearance="outline"
    >
      <textarea
        #textarea
        matInput
        formControlName="data"
      >
      </textarea>
      <mat-error *ngIf="form.controls['data'].hasError('pattern')">Must be comma separated numbers, no spaces, and not end with a comma. (i.e. 100001,100002)</mat-error>
      <mat-error *ngIf="form.controls['data'].hasError('maxIds')">Too many IDs. Cannot be greater than {{ maxIdCount }}.</mat-error>
      <mat-error *ngIf="form.controls['data'].hasError('required')">At least one {{ inputLabel }} is required.</mat-error>
      <mat-error *ngIf="form.controls['data'].hasError('minimumId')">All IDs must be greater than {{ idMinimum }}.</mat-error>
    </mat-form-field>
  </div>
  <div class="button-container">
    <button
      mat-flat-button
      color="accent"
      (click)="onDownloadClick()"
      [disabled]="!form.controls['data'].value"
    >
      Download {{ inputLabel }}
    </button>
    <app-download-all
      *ngIf="downloadAllConfig"
      [config]="downloadAllConfig"
    ></app-download-all>
    <button
      mat-stroked-button
      color="error"
      class="button-find-invalid-ids"
      (click)="onFindInvalidIdsClick()"
      *ngIf="form.controls['data'].hasError('minimumId')"
    >
      Find Invalid IDs
    </button>
  </div>
</div>
